import { Mode as nn, JSONEditor as en } from "vanilla-jsoneditor";
import { isVue3 as St, defineComponent as on, getCurrentInstance as an, ref as pt, watchEffect as cn, computed as Rt, onUnmounted as un, onMounted as fn, watch as vt, unref as sn, h as ln } from "vue-demi";
var pn = typeof global == "object" && global && global.Object === Object && global, vn = typeof self == "object" && self && self.Object === Object && self, Sr = pn || vn || Function("return this")(), nt = Sr.Symbol, Er = Object.prototype, dn = Er.hasOwnProperty, bn = Er.toString, W = nt ? nt.toStringTag : void 0;
function yn(t) {
  var r = dn.call(t, W), n = t[W];
  try {
    t[W] = void 0;
    var e = !0;
  } catch {
  }
  var i = bn.call(t);
  return e && (r ? t[W] = n : delete t[W]), i;
}
var hn = Object.prototype, jn = hn.toString;
function gn(t) {
  return jn.call(t);
}
var mn = "[object Null]", _n = "[object Undefined]", Wt = nt ? nt.toStringTag : void 0;
function On(t) {
  return t == null ? t === void 0 ? _n : mn : Wt && Wt in Object(t) ? yn(t) : gn(t);
}
function wn(t) {
  return t != null && typeof t == "object";
}
var An = "[object Symbol]";
function xn(t) {
  return typeof t == "symbol" || wn(t) && On(t) == An;
}
var Sn = /\s/;
function En(t) {
  for (var r = t.length; r-- && Sn.test(t.charAt(r)); )
    ;
  return r;
}
var Tn = /^\s+/;
function kn(t) {
  return t && t.slice(0, En(t) + 1).replace(Tn, "");
}
function jt(t) {
  var r = typeof t;
  return t != null && (r == "object" || r == "function");
}
var Vt = NaN, In = /^[-+]0x[0-9a-f]+$/i, Pn = /^0b[01]+$/i, zn = /^0o[0-7]+$/i, Cn = parseInt;
function Gt(t) {
  if (typeof t == "number")
    return t;
  if (xn(t))
    return Vt;
  if (jt(t)) {
    var r = typeof t.valueOf == "function" ? t.valueOf() : t;
    t = jt(r) ? r + "" : r;
  }
  if (typeof t != "string")
    return t === 0 ? t : +t;
  t = kn(t);
  var n = Pn.test(t);
  return n || zn.test(t) ? Cn(t.slice(2), n ? 2 : 8) : In.test(t) ? Vt : +t;
}
var dt = function() {
  return Sr.Date.now();
}, Fn = "Expected a function", $n = Math.max, Bn = Math.min;
function Ln(t, r, n) {
  var e, i, o, a, c, u, f = 0, l = !1, p = !1, v = !0;
  if (typeof t != "function")
    throw new TypeError(Fn);
  r = Gt(r) || 0, jt(n) && (l = !!n.leading, p = "maxWait" in n, o = p ? $n(Gt(n.maxWait) || 0, r) : o, v = "trailing" in n ? !!n.trailing : v);
  function y(m) {
    var C = e, R = i;
    return e = i = void 0, f = m, a = t.apply(R, C), a;
  }
  function b(m) {
    return f = m, c = setTimeout(d, r), l ? y(m) : a;
  }
  function s(m) {
    var C = m - u, R = m - f, Dt = r - C;
    return p ? Bn(Dt, o - R) : Dt;
  }
  function O(m) {
    var C = m - u, R = m - f;
    return u === void 0 || C >= r || C < 0 || p && R >= o;
  }
  function d() {
    var m = dt();
    if (O(m))
      return _(m);
    c = setTimeout(d, s(m));
  }
  function _(m) {
    return c = void 0, v && e ? y(m) : (e = i = void 0, a);
  }
  function h() {
    c !== void 0 && clearTimeout(c), f = 0, e = u = i = c = void 0;
  }
  function w() {
    return c === void 0 ? a : _(dt());
  }
  function A() {
    var m = dt(), C = O(m);
    if (e = arguments, i = this, u = m, C) {
      if (c === void 0)
        return b(u);
      if (p)
        return clearTimeout(c), c = setTimeout(d, r), y(u);
    }
    return c === void 0 && (c = setTimeout(d, r)), a;
  }
  return A.cancel = h, A.flush = w, A;
}
var Tr = typeof global == "object" && global && global.Object === Object && global, Mn = typeof self == "object" && self && self.Object === Object && self, k = Tr || Mn || Function("return this")(), E = k.Symbol, kr = Object.prototype, Un = kr.hasOwnProperty, Nn = kr.toString, V = E ? E.toStringTag : void 0;
function Dn(t) {
  var r = Un.call(t, V), n = t[V];
  try {
    t[V] = void 0;
    var e = !0;
  } catch {
  }
  var i = Nn.call(t);
  return e && (r ? t[V] = n : delete t[V]), i;
}
var Rn = Object.prototype, Wn = Rn.toString;
function Vn(t) {
  return Wn.call(t);
}
var Gn = "[object Null]", Jn = "[object Undefined]", Jt = E ? E.toStringTag : void 0;
function M(t) {
  return t == null ? t === void 0 ? Jn : Gn : Jt && Jt in Object(t) ? Dn(t) : Vn(t);
}
function T(t) {
  return t != null && typeof t == "object";
}
var qn = "[object Symbol]";
function Et(t) {
  return typeof t == "symbol" || T(t) && M(t) == qn;
}
function Kn(t, r) {
  for (var n = -1, e = t == null ? 0 : t.length, i = Array(e); ++n < e; )
    i[n] = r(t[n], n, t);
  return i;
}
var x = Array.isArray, Hn = 1 / 0, qt = E ? E.prototype : void 0, Kt = qt ? qt.toString : void 0;
function Ir(t) {
  if (typeof t == "string")
    return t;
  if (x(t))
    return Kn(t, Ir) + "";
  if (Et(t))
    return Kt ? Kt.call(t) : "";
  var r = t + "";
  return r == "0" && 1 / t == -Hn ? "-0" : r;
}
function I(t) {
  var r = typeof t;
  return t != null && (r == "object" || r == "function");
}
function Tt(t) {
  return t;
}
var Xn = "[object AsyncFunction]", Qn = "[object Function]", Zn = "[object GeneratorFunction]", Yn = "[object Proxy]";
function kt(t) {
  if (!I(t))
    return !1;
  var r = M(t);
  return r == Qn || r == Zn || r == Xn || r == Yn;
}
var bt = k["__core-js_shared__"], Ht = function() {
  var t = /[^.]+$/.exec(bt && bt.keys && bt.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}();
function te(t) {
  return !!Ht && Ht in t;
}
var re = Function.prototype, ne = re.toString;
function U(t) {
  if (t != null) {
    try {
      return ne.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
var ee = /[\\^$.*+?()[\]{}|]/g, oe = /^\[object .+?Constructor\]$/, ie = Function.prototype, ae = Object.prototype, ce = ie.toString, ue = ae.hasOwnProperty, fe = RegExp(
  "^" + ce.call(ue).replace(ee, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function se(t) {
  if (!I(t) || te(t))
    return !1;
  var r = kt(t) ? fe : oe;
  return r.test(U(t));
}
function le(t, r) {
  return t == null ? void 0 : t[r];
}
function N(t, r) {
  var n = le(t, r);
  return se(n) ? n : void 0;
}
var gt = N(k, "WeakMap"), Xt = Object.create, pe = /* @__PURE__ */ function() {
  function t() {
  }
  return function(r) {
    if (!I(r))
      return {};
    if (Xt)
      return Xt(r);
    t.prototype = r;
    var n = new t();
    return t.prototype = void 0, n;
  };
}();
function ve(t, r, n) {
  switch (n.length) {
    case 0:
      return t.call(r);
    case 1:
      return t.call(r, n[0]);
    case 2:
      return t.call(r, n[0], n[1]);
    case 3:
      return t.call(r, n[0], n[1], n[2]);
  }
  return t.apply(r, n);
}
function de(t, r) {
  var n = -1, e = t.length;
  for (r || (r = Array(e)); ++n < e; )
    r[n] = t[n];
  return r;
}
var be = 800, ye = 16, he = Date.now;
function je(t) {
  var r = 0, n = 0;
  return function() {
    var e = he(), i = ye - (e - n);
    if (n = e, i > 0) {
      if (++r >= be)
        return arguments[0];
    } else
      r = 0;
    return t.apply(void 0, arguments);
  };
}
function ge(t) {
  return function() {
    return t;
  };
}
var et = function() {
  try {
    var t = N(Object, "defineProperty");
    return t({}, "", {}), t;
  } catch {
  }
}(), me = et ? function(t, r) {
  return et(t, "toString", {
    configurable: !0,
    enumerable: !1,
    value: ge(r),
    writable: !0
  });
} : Tt;
const _e = me;
var Oe = je(_e);
function we(t, r) {
  for (var n = -1, e = t == null ? 0 : t.length; ++n < e && r(t[n], n, t) !== !1; )
    ;
  return t;
}
var Ae = 9007199254740991, xe = /^(?:0|[1-9]\d*)$/;
function It(t, r) {
  var n = typeof t;
  return r = r ?? Ae, !!r && (n == "number" || n != "symbol" && xe.test(t)) && t > -1 && t % 1 == 0 && t < r;
}
function ct(t, r, n) {
  r == "__proto__" && et ? et(t, r, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : t[r] = n;
}
function Q(t, r) {
  return t === r || t !== t && r !== r;
}
var Se = Object.prototype, Ee = Se.hasOwnProperty;
function Pr(t, r, n) {
  var e = t[r];
  (!(Ee.call(t, r) && Q(e, n)) || n === void 0 && !(r in t)) && ct(t, r, n);
}
function zr(t, r, n, e) {
  var i = !n;
  n || (n = {});
  for (var o = -1, a = r.length; ++o < a; ) {
    var c = r[o], u = e ? e(n[c], t[c], c, n, t) : void 0;
    u === void 0 && (u = t[c]), i ? ct(n, c, u) : Pr(n, c, u);
  }
  return n;
}
var Qt = Math.max;
function Te(t, r, n) {
  return r = Qt(r === void 0 ? t.length - 1 : r, 0), function() {
    for (var e = arguments, i = -1, o = Qt(e.length - r, 0), a = Array(o); ++i < o; )
      a[i] = e[r + i];
    i = -1;
    for (var c = Array(r + 1); ++i < r; )
      c[i] = e[i];
    return c[r] = n(a), ve(t, this, c);
  };
}
function ke(t, r) {
  return Oe(Te(t, r, Tt), t + "");
}
var Ie = 9007199254740991;
function Pt(t) {
  return typeof t == "number" && t > -1 && t % 1 == 0 && t <= Ie;
}
function ut(t) {
  return t != null && Pt(t.length) && !kt(t);
}
function Pe(t, r, n) {
  if (!I(n))
    return !1;
  var e = typeof r;
  return (e == "number" ? ut(n) && It(r, n.length) : e == "string" && r in n) ? Q(n[r], t) : !1;
}
function Cr(t) {
  return ke(function(r, n) {
    var e = -1, i = n.length, o = i > 1 ? n[i - 1] : void 0, a = i > 2 ? n[2] : void 0;
    for (o = t.length > 3 && typeof o == "function" ? (i--, o) : void 0, a && Pe(n[0], n[1], a) && (o = i < 3 ? void 0 : o, i = 1), r = Object(r); ++e < i; ) {
      var c = n[e];
      c && t(r, c, e, o);
    }
    return r;
  });
}
var ze = Object.prototype;
function zt(t) {
  var r = t && t.constructor, n = typeof r == "function" && r.prototype || ze;
  return t === n;
}
function Ce(t, r) {
  for (var n = -1, e = Array(t); ++n < t; )
    e[n] = r(n);
  return e;
}
var Fe = "[object Arguments]";
function Zt(t) {
  return T(t) && M(t) == Fe;
}
var Fr = Object.prototype, $e = Fr.hasOwnProperty, Be = Fr.propertyIsEnumerable, ot = Zt(/* @__PURE__ */ function() {
  return arguments;
}()) ? Zt : function(t) {
  return T(t) && $e.call(t, "callee") && !Be.call(t, "callee");
};
function Le() {
  return !1;
}
var $r = typeof exports == "object" && exports && !exports.nodeType && exports, Yt = $r && typeof module == "object" && module && !module.nodeType && module, Me = Yt && Yt.exports === $r, tr = Me ? k.Buffer : void 0, Ue = tr ? tr.isBuffer : void 0, q = Ue || Le, Ne = "[object Arguments]", De = "[object Array]", Re = "[object Boolean]", We = "[object Date]", Ve = "[object Error]", Ge = "[object Function]", Je = "[object Map]", qe = "[object Number]", Ke = "[object Object]", He = "[object RegExp]", Xe = "[object Set]", Qe = "[object String]", Ze = "[object WeakMap]", Ye = "[object ArrayBuffer]", to = "[object DataView]", ro = "[object Float32Array]", no = "[object Float64Array]", eo = "[object Int8Array]", oo = "[object Int16Array]", io = "[object Int32Array]", ao = "[object Uint8Array]", co = "[object Uint8ClampedArray]", uo = "[object Uint16Array]", fo = "[object Uint32Array]", g = {};
g[ro] = g[no] = g[eo] = g[oo] = g[io] = g[ao] = g[co] = g[uo] = g[fo] = !0;
g[Ne] = g[De] = g[Ye] = g[Re] = g[to] = g[We] = g[Ve] = g[Ge] = g[Je] = g[qe] = g[Ke] = g[He] = g[Xe] = g[Qe] = g[Ze] = !1;
function so(t) {
  return T(t) && Pt(t.length) && !!g[M(t)];
}
function Ct(t) {
  return function(r) {
    return t(r);
  };
}
var Br = typeof exports == "object" && exports && !exports.nodeType && exports, G = Br && typeof module == "object" && module && !module.nodeType && module, lo = G && G.exports === Br, yt = lo && Tr.process, D = function() {
  try {
    var t = G && G.require && G.require("util").types;
    return t || yt && yt.binding && yt.binding("util");
  } catch {
  }
}(), rr = D && D.isTypedArray, Ft = rr ? Ct(rr) : so, po = Object.prototype, vo = po.hasOwnProperty;
function Lr(t, r) {
  var n = x(t), e = !n && ot(t), i = !n && !e && q(t), o = !n && !e && !i && Ft(t), a = n || e || i || o, c = a ? Ce(t.length, String) : [], u = c.length;
  for (var f in t)
    (r || vo.call(t, f)) && !(a && // Safari 9 has enumerable `arguments.length` in strict mode.
    (f == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (f == "offset" || f == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    o && (f == "buffer" || f == "byteLength" || f == "byteOffset") || // Skip index properties.
    It(f, u))) && c.push(f);
  return c;
}
function Mr(t, r) {
  return function(n) {
    return t(r(n));
  };
}
var bo = Mr(Object.keys, Object), yo = Object.prototype, ho = yo.hasOwnProperty;
function jo(t) {
  if (!zt(t))
    return bo(t);
  var r = [];
  for (var n in Object(t))
    ho.call(t, n) && n != "constructor" && r.push(n);
  return r;
}
function $t(t) {
  return ut(t) ? Lr(t) : jo(t);
}
function go(t) {
  var r = [];
  if (t != null)
    for (var n in Object(t))
      r.push(n);
  return r;
}
var mo = Object.prototype, _o = mo.hasOwnProperty;
function Oo(t) {
  if (!I(t))
    return go(t);
  var r = zt(t), n = [];
  for (var e in t)
    e == "constructor" && (r || !_o.call(t, e)) || n.push(e);
  return n;
}
function Bt(t) {
  return ut(t) ? Lr(t, !0) : Oo(t);
}
var wo = Cr(function(t, r, n, e) {
  zr(r, Bt(r), t, e);
}), Ao = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, xo = /^\w*$/;
function Lt(t, r) {
  if (x(t))
    return !1;
  var n = typeof t;
  return n == "number" || n == "symbol" || n == "boolean" || t == null || Et(t) ? !0 : xo.test(t) || !Ao.test(t) || r != null && t in Object(r);
}
var K = N(Object, "create");
function So() {
  this.__data__ = K ? K(null) : {}, this.size = 0;
}
function Eo(t) {
  var r = this.has(t) && delete this.__data__[t];
  return this.size -= r ? 1 : 0, r;
}
var To = "__lodash_hash_undefined__", ko = Object.prototype, Io = ko.hasOwnProperty;
function Po(t) {
  var r = this.__data__;
  if (K) {
    var n = r[t];
    return n === To ? void 0 : n;
  }
  return Io.call(r, t) ? r[t] : void 0;
}
var zo = Object.prototype, Co = zo.hasOwnProperty;
function Fo(t) {
  var r = this.__data__;
  return K ? r[t] !== void 0 : Co.call(r, t);
}
var $o = "__lodash_hash_undefined__";
function Bo(t, r) {
  var n = this.__data__;
  return this.size += this.has(t) ? 0 : 1, n[t] = K && r === void 0 ? $o : r, this;
}
function L(t) {
  var r = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++r < n; ) {
    var e = t[r];
    this.set(e[0], e[1]);
  }
}
L.prototype.clear = So;
L.prototype.delete = Eo;
L.prototype.get = Po;
L.prototype.has = Fo;
L.prototype.set = Bo;
function Lo() {
  this.__data__ = [], this.size = 0;
}
function ft(t, r) {
  for (var n = t.length; n--; )
    if (Q(t[n][0], r))
      return n;
  return -1;
}
var Mo = Array.prototype, Uo = Mo.splice;
function No(t) {
  var r = this.__data__, n = ft(r, t);
  if (n < 0)
    return !1;
  var e = r.length - 1;
  return n == e ? r.pop() : Uo.call(r, n, 1), --this.size, !0;
}
function Do(t) {
  var r = this.__data__, n = ft(r, t);
  return n < 0 ? void 0 : r[n][1];
}
function Ro(t) {
  return ft(this.__data__, t) > -1;
}
function Wo(t, r) {
  var n = this.__data__, e = ft(n, t);
  return e < 0 ? (++this.size, n.push([t, r])) : n[e][1] = r, this;
}
function P(t) {
  var r = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++r < n; ) {
    var e = t[r];
    this.set(e[0], e[1]);
  }
}
P.prototype.clear = Lo;
P.prototype.delete = No;
P.prototype.get = Do;
P.prototype.has = Ro;
P.prototype.set = Wo;
var H = N(k, "Map");
function Vo() {
  this.size = 0, this.__data__ = {
    hash: new L(),
    map: new (H || P)(),
    string: new L()
  };
}
function Go(t) {
  var r = typeof t;
  return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? t !== "__proto__" : t === null;
}
function st(t, r) {
  var n = t.__data__;
  return Go(r) ? n[typeof r == "string" ? "string" : "hash"] : n.map;
}
function Jo(t) {
  var r = st(this, t).delete(t);
  return this.size -= r ? 1 : 0, r;
}
function qo(t) {
  return st(this, t).get(t);
}
function Ko(t) {
  return st(this, t).has(t);
}
function Ho(t, r) {
  var n = st(this, t), e = n.size;
  return n.set(t, r), this.size += n.size == e ? 0 : 1, this;
}
function z(t) {
  var r = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++r < n; ) {
    var e = t[r];
    this.set(e[0], e[1]);
  }
}
z.prototype.clear = Vo;
z.prototype.delete = Jo;
z.prototype.get = qo;
z.prototype.has = Ko;
z.prototype.set = Ho;
var Xo = "Expected a function";
function Mt(t, r) {
  if (typeof t != "function" || r != null && typeof r != "function")
    throw new TypeError(Xo);
  var n = function() {
    var e = arguments, i = r ? r.apply(this, e) : e[0], o = n.cache;
    if (o.has(i))
      return o.get(i);
    var a = t.apply(this, e);
    return n.cache = o.set(i, a) || o, a;
  };
  return n.cache = new (Mt.Cache || z)(), n;
}
Mt.Cache = z;
var Qo = 500;
function Zo(t) {
  var r = Mt(t, function(e) {
    return n.size === Qo && n.clear(), e;
  }), n = r.cache;
  return r;
}
var Yo = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, ti = /\\(\\)?/g, ri = Zo(function(t) {
  var r = [];
  return t.charCodeAt(0) === 46 && r.push(""), t.replace(Yo, function(n, e, i, o) {
    r.push(i ? o.replace(ti, "$1") : e || n);
  }), r;
});
function ni(t) {
  return t == null ? "" : Ir(t);
}
function Ur(t, r) {
  return x(t) ? t : Lt(t, r) ? [t] : ri(ni(t));
}
var ei = 1 / 0;
function lt(t) {
  if (typeof t == "string" || Et(t))
    return t;
  var r = t + "";
  return r == "0" && 1 / t == -ei ? "-0" : r;
}
function Nr(t, r) {
  r = Ur(r, t);
  for (var n = 0, e = r.length; t != null && n < e; )
    t = t[lt(r[n++])];
  return n && n == e ? t : void 0;
}
function oi(t, r, n) {
  var e = t == null ? void 0 : Nr(t, r);
  return e === void 0 ? n : e;
}
function ii(t, r) {
  for (var n = -1, e = r.length, i = t.length; ++n < e; )
    t[i + n] = r[n];
  return t;
}
var ai = Mr(Object.getPrototypeOf, Object);
const Dr = ai;
var ci = "[object Object]", ui = Function.prototype, fi = Object.prototype, Rr = ui.toString, si = fi.hasOwnProperty, li = Rr.call(Object);
function pi(t) {
  if (!T(t) || M(t) != ci)
    return !1;
  var r = Dr(t);
  if (r === null)
    return !0;
  var n = si.call(r, "constructor") && r.constructor;
  return typeof n == "function" && n instanceof n && Rr.call(n) == li;
}
function vi() {
  this.__data__ = new P(), this.size = 0;
}
function di(t) {
  var r = this.__data__, n = r.delete(t);
  return this.size = r.size, n;
}
function bi(t) {
  return this.__data__.get(t);
}
function yi(t) {
  return this.__data__.has(t);
}
var hi = 200;
function ji(t, r) {
  var n = this.__data__;
  if (n instanceof P) {
    var e = n.__data__;
    if (!H || e.length < hi - 1)
      return e.push([t, r]), this.size = ++n.size, this;
    n = this.__data__ = new z(e);
  }
  return n.set(t, r), this.size = n.size, this;
}
function S(t) {
  var r = this.__data__ = new P(t);
  this.size = r.size;
}
S.prototype.clear = vi;
S.prototype.delete = di;
S.prototype.get = bi;
S.prototype.has = yi;
S.prototype.set = ji;
var Wr = typeof exports == "object" && exports && !exports.nodeType && exports, nr = Wr && typeof module == "object" && module && !module.nodeType && module, gi = nr && nr.exports === Wr, er = gi ? k.Buffer : void 0, or = er ? er.allocUnsafe : void 0;
function Vr(t, r) {
  if (r)
    return t.slice();
  var n = t.length, e = or ? or(n) : new t.constructor(n);
  return t.copy(e), e;
}
function mi(t, r) {
  for (var n = -1, e = t == null ? 0 : t.length, i = 0, o = []; ++n < e; ) {
    var a = t[n];
    r(a, n, t) && (o[i++] = a);
  }
  return o;
}
function _i() {
  return [];
}
var Oi = Object.prototype, wi = Oi.propertyIsEnumerable, ir = Object.getOwnPropertySymbols, Ai = ir ? function(t) {
  return t == null ? [] : (t = Object(t), mi(ir(t), function(r) {
    return wi.call(t, r);
  }));
} : _i;
function xi(t, r, n) {
  var e = r(t);
  return x(t) ? e : ii(e, n(t));
}
function mt(t) {
  return xi(t, $t, Ai);
}
var _t = N(k, "DataView"), Ot = N(k, "Promise"), wt = N(k, "Set"), ar = "[object Map]", Si = "[object Object]", cr = "[object Promise]", ur = "[object Set]", fr = "[object WeakMap]", sr = "[object DataView]", Ei = U(_t), Ti = U(H), ki = U(Ot), Ii = U(wt), Pi = U(gt), B = M;
(_t && B(new _t(new ArrayBuffer(1))) != sr || H && B(new H()) != ar || Ot && B(Ot.resolve()) != cr || wt && B(new wt()) != ur || gt && B(new gt()) != fr) && (B = function(t) {
  var r = M(t), n = r == Si ? t.constructor : void 0, e = n ? U(n) : "";
  if (e)
    switch (e) {
      case Ei:
        return sr;
      case Ti:
        return ar;
      case ki:
        return cr;
      case Ii:
        return ur;
      case Pi:
        return fr;
    }
  return r;
});
const X = B;
var zi = Object.prototype, Ci = zi.hasOwnProperty;
function Fi(t) {
  var r = t.length, n = new t.constructor(r);
  return r && typeof t[0] == "string" && Ci.call(t, "index") && (n.index = t.index, n.input = t.input), n;
}
var it = k.Uint8Array;
function Ut(t) {
  var r = new t.constructor(t.byteLength);
  return new it(r).set(new it(t)), r;
}
function $i(t, r) {
  var n = Ut(t.buffer);
  return new t.constructor(n, t.byteOffset, t.byteLength);
}
var Bi = /\w*$/;
function Li(t) {
  var r = new t.constructor(t.source, Bi.exec(t));
  return r.lastIndex = t.lastIndex, r;
}
var lr = E ? E.prototype : void 0, pr = lr ? lr.valueOf : void 0;
function Mi(t) {
  return pr ? Object(pr.call(t)) : {};
}
function Gr(t, r) {
  var n = r ? Ut(t.buffer) : t.buffer;
  return new t.constructor(n, t.byteOffset, t.length);
}
var Ui = "[object Boolean]", Ni = "[object Date]", Di = "[object Map]", Ri = "[object Number]", Wi = "[object RegExp]", Vi = "[object Set]", Gi = "[object String]", Ji = "[object Symbol]", qi = "[object ArrayBuffer]", Ki = "[object DataView]", Hi = "[object Float32Array]", Xi = "[object Float64Array]", Qi = "[object Int8Array]", Zi = "[object Int16Array]", Yi = "[object Int32Array]", ta = "[object Uint8Array]", ra = "[object Uint8ClampedArray]", na = "[object Uint16Array]", ea = "[object Uint32Array]";
function oa(t, r, n) {
  var e = t.constructor;
  switch (r) {
    case qi:
      return Ut(t);
    case Ui:
    case Ni:
      return new e(+t);
    case Ki:
      return $i(t);
    case Hi:
    case Xi:
    case Qi:
    case Zi:
    case Yi:
    case ta:
    case ra:
    case na:
    case ea:
      return Gr(t, n);
    case Di:
      return new e();
    case Ri:
    case Gi:
      return new e(t);
    case Wi:
      return Li(t);
    case Vi:
      return new e();
    case Ji:
      return Mi(t);
  }
}
function Jr(t) {
  return typeof t.constructor == "function" && !zt(t) ? pe(Dr(t)) : {};
}
var ia = "[object Map]";
function aa(t) {
  return T(t) && X(t) == ia;
}
var vr = D && D.isMap, ca = vr ? Ct(vr) : aa, ua = "[object Set]";
function fa(t) {
  return T(t) && X(t) == ua;
}
var dr = D && D.isSet, sa = dr ? Ct(dr) : fa, la = 1, qr = "[object Arguments]", pa = "[object Array]", va = "[object Boolean]", da = "[object Date]", ba = "[object Error]", Kr = "[object Function]", ya = "[object GeneratorFunction]", ha = "[object Map]", ja = "[object Number]", Hr = "[object Object]", ga = "[object RegExp]", ma = "[object Set]", _a = "[object String]", Oa = "[object Symbol]", wa = "[object WeakMap]", Aa = "[object ArrayBuffer]", xa = "[object DataView]", Sa = "[object Float32Array]", Ea = "[object Float64Array]", Ta = "[object Int8Array]", ka = "[object Int16Array]", Ia = "[object Int32Array]", Pa = "[object Uint8Array]", za = "[object Uint8ClampedArray]", Ca = "[object Uint16Array]", Fa = "[object Uint32Array]", j = {};
j[qr] = j[pa] = j[Aa] = j[xa] = j[va] = j[da] = j[Sa] = j[Ea] = j[Ta] = j[ka] = j[Ia] = j[ha] = j[ja] = j[Hr] = j[ga] = j[ma] = j[_a] = j[Oa] = j[Pa] = j[za] = j[Ca] = j[Fa] = !0;
j[ba] = j[Kr] = j[wa] = !1;
function Y(t, r, n, e, i, o) {
  var a, c = r & la;
  if (a !== void 0)
    return a;
  if (!I(t))
    return t;
  var u = x(t);
  if (u)
    a = Fi(t);
  else {
    var f = X(t), l = f == Kr || f == ya;
    if (q(t))
      return Vr(t, c);
    if (f == Hr || f == qr || l && !i)
      a = l ? {} : Jr(t);
    else {
      if (!j[f])
        return i ? t : {};
      a = oa(t, f, c);
    }
  }
  o || (o = new S());
  var p = o.get(t);
  if (p)
    return p;
  o.set(t, a), sa(t) ? t.forEach(function(b) {
    a.add(Y(b, r, n, b, t, o));
  }) : ca(t) && t.forEach(function(b, s) {
    a.set(s, Y(b, r, n, s, t, o));
  });
  var v = mt, y = u ? void 0 : v(t);
  return we(y || t, function(b, s) {
    y && (s = b, b = t[s]), Pr(a, s, Y(b, r, n, s, t, o));
  }), a;
}
var $a = 1, Ba = 4;
function La(t) {
  return Y(t, $a | Ba);
}
var Ma = "__lodash_hash_undefined__";
function Ua(t) {
  return this.__data__.set(t, Ma), this;
}
function Na(t) {
  return this.__data__.has(t);
}
function at(t) {
  var r = -1, n = t == null ? 0 : t.length;
  for (this.__data__ = new z(); ++r < n; )
    this.add(t[r]);
}
at.prototype.add = at.prototype.push = Ua;
at.prototype.has = Na;
function Da(t, r) {
  for (var n = -1, e = t == null ? 0 : t.length; ++n < e; )
    if (r(t[n], n, t))
      return !0;
  return !1;
}
function Ra(t, r) {
  return t.has(r);
}
var Wa = 1, Va = 2;
function Xr(t, r, n, e, i, o) {
  var a = n & Wa, c = t.length, u = r.length;
  if (c != u && !(a && u > c))
    return !1;
  var f = o.get(t), l = o.get(r);
  if (f && l)
    return f == r && l == t;
  var p = -1, v = !0, y = n & Va ? new at() : void 0;
  for (o.set(t, r), o.set(r, t); ++p < c; ) {
    var b = t[p], s = r[p];
    if (e)
      var O = a ? e(s, b, p, r, t, o) : e(b, s, p, t, r, o);
    if (O !== void 0) {
      if (O)
        continue;
      v = !1;
      break;
    }
    if (y) {
      if (!Da(r, function(d, _) {
        if (!Ra(y, _) && (b === d || i(b, d, n, e, o)))
          return y.push(_);
      })) {
        v = !1;
        break;
      }
    } else if (!(b === s || i(b, s, n, e, o))) {
      v = !1;
      break;
    }
  }
  return o.delete(t), o.delete(r), v;
}
function Ga(t) {
  var r = -1, n = Array(t.size);
  return t.forEach(function(e, i) {
    n[++r] = [i, e];
  }), n;
}
function Ja(t) {
  var r = -1, n = Array(t.size);
  return t.forEach(function(e) {
    n[++r] = e;
  }), n;
}
var qa = 1, Ka = 2, Ha = "[object Boolean]", Xa = "[object Date]", Qa = "[object Error]", Za = "[object Map]", Ya = "[object Number]", tc = "[object RegExp]", rc = "[object Set]", nc = "[object String]", ec = "[object Symbol]", oc = "[object ArrayBuffer]", ic = "[object DataView]", br = E ? E.prototype : void 0, ht = br ? br.valueOf : void 0;
function ac(t, r, n, e, i, o, a) {
  switch (n) {
    case ic:
      if (t.byteLength != r.byteLength || t.byteOffset != r.byteOffset)
        return !1;
      t = t.buffer, r = r.buffer;
    case oc:
      return !(t.byteLength != r.byteLength || !o(new it(t), new it(r)));
    case Ha:
    case Xa:
    case Ya:
      return Q(+t, +r);
    case Qa:
      return t.name == r.name && t.message == r.message;
    case tc:
    case nc:
      return t == r + "";
    case Za:
      var c = Ga;
    case rc:
      var u = e & qa;
      if (c || (c = Ja), t.size != r.size && !u)
        return !1;
      var f = a.get(t);
      if (f)
        return f == r;
      e |= Ka, a.set(t, r);
      var l = Xr(c(t), c(r), e, i, o, a);
      return a.delete(t), l;
    case ec:
      if (ht)
        return ht.call(t) == ht.call(r);
  }
  return !1;
}
var cc = 1, uc = Object.prototype, fc = uc.hasOwnProperty;
function sc(t, r, n, e, i, o) {
  var a = n & cc, c = mt(t), u = c.length, f = mt(r), l = f.length;
  if (u != l && !a)
    return !1;
  for (var p = u; p--; ) {
    var v = c[p];
    if (!(a ? v in r : fc.call(r, v)))
      return !1;
  }
  var y = o.get(t), b = o.get(r);
  if (y && b)
    return y == r && b == t;
  var s = !0;
  o.set(t, r), o.set(r, t);
  for (var O = a; ++p < u; ) {
    v = c[p];
    var d = t[v], _ = r[v];
    if (e)
      var h = a ? e(_, d, v, r, t, o) : e(d, _, v, t, r, o);
    if (!(h === void 0 ? d === _ || i(d, _, n, e, o) : h)) {
      s = !1;
      break;
    }
    O || (O = v == "constructor");
  }
  if (s && !O) {
    var w = t.constructor, A = r.constructor;
    w != A && "constructor" in t && "constructor" in r && !(typeof w == "function" && w instanceof w && typeof A == "function" && A instanceof A) && (s = !1);
  }
  return o.delete(t), o.delete(r), s;
}
var lc = 1, yr = "[object Arguments]", hr = "[object Array]", Z = "[object Object]", pc = Object.prototype, jr = pc.hasOwnProperty;
function vc(t, r, n, e, i, o) {
  var a = x(t), c = x(r), u = a ? hr : X(t), f = c ? hr : X(r);
  u = u == yr ? Z : u, f = f == yr ? Z : f;
  var l = u == Z, p = f == Z, v = u == f;
  if (v && q(t)) {
    if (!q(r))
      return !1;
    a = !0, l = !1;
  }
  if (v && !l)
    return o || (o = new S()), a || Ft(t) ? Xr(t, r, n, e, i, o) : ac(t, r, u, n, e, i, o);
  if (!(n & lc)) {
    var y = l && jr.call(t, "__wrapped__"), b = p && jr.call(r, "__wrapped__");
    if (y || b) {
      var s = y ? t.value() : t, O = b ? r.value() : r;
      return o || (o = new S()), i(s, O, n, e, o);
    }
  }
  return v ? (o || (o = new S()), sc(t, r, n, e, i, o)) : !1;
}
function Nt(t, r, n, e, i) {
  return t === r ? !0 : t == null || r == null || !T(t) && !T(r) ? t !== t && r !== r : vc(t, r, n, e, Nt, i);
}
var dc = 1, bc = 2;
function yc(t, r, n, e) {
  var i = n.length, o = i;
  if (t == null)
    return !o;
  for (t = Object(t); i--; ) {
    var a = n[i];
    if (a[2] ? a[1] !== t[a[0]] : !(a[0] in t))
      return !1;
  }
  for (; ++i < o; ) {
    a = n[i];
    var c = a[0], u = t[c], f = a[1];
    if (a[2]) {
      if (u === void 0 && !(c in t))
        return !1;
    } else {
      var l = new S(), p;
      if (!(p === void 0 ? Nt(f, u, dc | bc, e, l) : p))
        return !1;
    }
  }
  return !0;
}
function Qr(t) {
  return t === t && !I(t);
}
function hc(t) {
  for (var r = $t(t), n = r.length; n--; ) {
    var e = r[n], i = t[e];
    r[n] = [e, i, Qr(i)];
  }
  return r;
}
function Zr(t, r) {
  return function(n) {
    return n == null ? !1 : n[t] === r && (r !== void 0 || t in Object(n));
  };
}
function jc(t) {
  var r = hc(t);
  return r.length == 1 && r[0][2] ? Zr(r[0][0], r[0][1]) : function(n) {
    return n === t || yc(n, t, r);
  };
}
function gc(t, r) {
  return t != null && r in Object(t);
}
function mc(t, r, n) {
  r = Ur(r, t);
  for (var e = -1, i = r.length, o = !1; ++e < i; ) {
    var a = lt(r[e]);
    if (!(o = t != null && n(t, a)))
      break;
    t = t[a];
  }
  return o || ++e != i ? o : (i = t == null ? 0 : t.length, !!i && Pt(i) && It(a, i) && (x(t) || ot(t)));
}
function _c(t, r) {
  return t != null && mc(t, r, gc);
}
var Oc = 1, wc = 2;
function Ac(t, r) {
  return Lt(t) && Qr(r) ? Zr(lt(t), r) : function(n) {
    var e = oi(n, t);
    return e === void 0 && e === r ? _c(n, t) : Nt(r, e, Oc | wc);
  };
}
function xc(t) {
  return function(r) {
    return r == null ? void 0 : r[t];
  };
}
function Sc(t) {
  return function(r) {
    return Nr(r, t);
  };
}
function Ec(t) {
  return Lt(t) ? xc(lt(t)) : Sc(t);
}
function Tc(t) {
  return typeof t == "function" ? t : t == null ? Tt : typeof t == "object" ? x(t) ? Ac(t[0], t[1]) : jc(t) : Ec(t);
}
function kc(t) {
  return function(r, n, e) {
    for (var i = -1, o = Object(r), a = e(r), c = a.length; c--; ) {
      var u = a[++i];
      if (n(o[u], u, o) === !1)
        break;
    }
    return r;
  };
}
var Yr = kc();
function Ic(t, r) {
  return t && Yr(t, r, $t);
}
function At(t, r, n) {
  (n !== void 0 && !Q(t[r], n) || n === void 0 && !(r in t)) && ct(t, r, n);
}
function Pc(t) {
  return T(t) && ut(t);
}
function xt(t, r) {
  if (!(r === "constructor" && typeof t[r] == "function") && r != "__proto__")
    return t[r];
}
function zc(t) {
  return zr(t, Bt(t));
}
function Cc(t, r, n, e, i, o, a) {
  var c = xt(t, n), u = xt(r, n), f = a.get(u);
  if (f) {
    At(t, n, f);
    return;
  }
  var l = o ? o(c, u, n + "", t, r, a) : void 0, p = l === void 0;
  if (p) {
    var v = x(u), y = !v && q(u), b = !v && !y && Ft(u);
    l = u, v || y || b ? x(c) ? l = c : Pc(c) ? l = de(c) : y ? (p = !1, l = Vr(u, !0)) : b ? (p = !1, l = Gr(u, !0)) : l = [] : pi(u) || ot(u) ? (l = c, ot(c) ? l = zc(c) : (!I(c) || kt(c)) && (l = Jr(u))) : p = !1;
  }
  p && (a.set(u, l), i(l, u, e, o, a), a.delete(u)), At(t, n, l);
}
function tn(t, r, n, e, i) {
  t !== r && Yr(r, function(o, a) {
    if (i || (i = new S()), I(o))
      Cc(t, r, a, n, tn, e, i);
    else {
      var c = e ? e(xt(t, a), o, a + "", t, r, i) : void 0;
      c === void 0 && (c = o), At(t, a, c);
    }
  }, Bt);
}
var Fc = Cr(function(t, r, n, e) {
  tn(t, r, n, e);
});
function $c(t, r) {
  var n = {};
  return r = Tc(r), Ic(t, function(e, i, o) {
    ct(n, r(e, i, o), e);
  }), n;
}
const Bc = new RegExp("([\\p{Ll}\\d])(\\p{Lu})", "gu"), Lc = new RegExp("(\\p{Lu})([\\p{Lu}][\\p{Ll}])", "gu"), Mc = new RegExp("(\\d)\\p{Ll}|(\\p{L})\\d", "u"), Uc = /[^\p{L}\d]+/giu, gr = "$1\0$2", mr = "";
function rn(t) {
  let r = t.trim();
  r = r.replace(Bc, gr).replace(Lc, gr), r = r.replace(Uc, "\0");
  let n = 0, e = r.length;
  for (; r.charAt(n) === "\0"; )
    n++;
  if (n === e)
    return [];
  for (; r.charAt(e - 1) === "\0"; )
    e--;
  return r.slice(n, e).split(/\0/g);
}
function Nc(t) {
  const r = rn(t);
  for (let n = 0; n < r.length; n++) {
    const e = r[n], i = Mc.exec(e);
    if (i) {
      const o = i.index + (i[1] ?? i[2]).length;
      r.splice(n, 1, e.slice(0, o), e.slice(o));
    }
  }
  return r;
}
function Dc(t, r) {
  const [n, e, i] = Gc(t, r), o = Rc(void 0), a = Wc(void 0), c = Vc(o, a);
  return n + e.map((u, f) => f === 0 ? o(u) : c(u, f)).join("") + i;
}
function Rc(t) {
  return (r) => r.toLocaleLowerCase(t);
}
function Wc(t) {
  return (r) => r.toLocaleUpperCase(t);
}
function Vc(t, r) {
  return (n, e) => {
    const i = n[0];
    return (e > 0 && i >= "0" && i <= "9" ? "_" + i : r(i)) + t(n.slice(1));
  };
}
function Gc(t, r = {}) {
  const n = r.split ?? (r.separateNumbers ? Nc : rn), e = r.prefixCharacters ?? mr, i = r.suffixCharacters ?? mr;
  let o = 0, a = t.length;
  for (; o < t.length; ) {
    const c = t.charAt(o);
    if (!e.includes(c))
      break;
    o++;
  }
  for (; a > o; ) {
    const c = a - 1, u = t.charAt(c);
    if (!i.includes(u))
      break;
    a = c;
  }
  return [
    t.slice(0, o),
    n(t.slice(o, a)),
    t.slice(a)
  ];
}
const J = (t) => /.+-.+/.test(t) ? Dc(t) : t, Jc = (t) => Object.prototype.toString.call(t).slice(8, -1) === "Object";
function qc(t, r) {
  const n = /* @__PURE__ */ Object.create(null), e = t.split(",");
  for (let i = 0; i < e.length; i++)
    n[e[i]] = !0;
  return (i) => !!n[i];
}
const Kc = /* @__PURE__ */ qc("String,Number,Boolean,Function,Symbol,BigInt");
function Hc(t) {
  const r = t == null ? void 0 : t.toString().match(/^\s*function (\w+)/);
  return r ? r[1] : t === null ? "null" : "";
}
function Xc(t, r) {
  let n;
  const e = Hc(r);
  if (Kc(e)) {
    const i = typeof t;
    n = i === e.toLowerCase(), !n && i === "object" && (n = t instanceof r);
  } else
    e === "Object" ? n = I(t) : e === "Array" ? n = Array.isArray(t) : e === "null" ? n = t === null : n = t instanceof r;
  return {
    valid: n,
    expectedType: e
  };
}
function Qc({
  prop: t,
  type: r,
  validator: n
}) {
  if (![void 0, null].includes(t) && r) {
    let e = !1;
    const i = Array.isArray(r) ? r : [r], o = [];
    for (let a = 0; a < i.length && !e; a++) {
      const { valid: c, expectedType: u } = Xc(t, i[a]);
      o.push(u || ""), e = c;
    }
    if (!e)
      throw new TypeError(
        `Invalid prop: type check failed, expecting [${o.join(
          ", "
        )}], receiving: ${t}`
      );
  }
  if (n && !n(t))
    throw new Error(`Invalid prop: validator check failed, receiving: ${t}`);
}
function Zc(t, {
  mergeObject: r,
  mergeFunction: n
}) {
  const e = [];
  for (let o = t.length - 1; o >= 0; o--)
    e.push(t[o]);
  const i = n ? (o, a) => typeof o == "function" && typeof a == "function" ? n(a, o) : void 0 : void 0;
  return r === "deep" ? Fc(...e, i) : wo(...e, i);
}
function Yc(t, {
  mergeFunction: r
}) {
  return t.reduce(r, () => {
  });
}
function $(t, r = {}) {
  const {
    type: n,
    default: e,
    defaultIsDynamic: i = !1,
    required: o = !1,
    validator: a,
    camelizeObjectKeys: c = !1,
    mergeObjectApplyOnlyToDefault: u = !1,
    mergeFunctionApplyOnlyToDefault: f = !0
  } = r;
  let { mergeObject: l = "deep", mergeFunction: p = !1 } = r;
  const v = [];
  let y, b = !1, s = !1;
  const O = (d) => {
    if (d !== void 0) {
      Qc({ type: n, prop: d, validator: a });
      const _ = Jc(d), h = typeof d == "function";
      return b = _, s = h, _ ? (d = La(d), c ? $c(d, (w, A) => J(A)) : d) : d;
    }
  };
  for (const d of t)
    v.push(O(d));
  if (!i)
    v.push(O(e));
  else if (typeof e != "function")
    throw new TypeError(
      `Invalid option: options.default should be Function when options.defaultIsDynamic enabled, receiving: ${e}`
    );
  b || (l = !1, s || (p = !1));
  for (let d = 0; d < v.length; d++) {
    const _ = v[d];
    if (_ !== void 0) {
      d === v.length - 1 ? y = _ : l ? y = Zc(
        u ? [_, e] : v,
        {
          mergeObject: l,
          mergeFunction: p
        }
      ) : p ? y = Yc(
        f ? [_, e] : v,
        {
          mergeFunction: p
        }
      ) : y = _;
      break;
    }
  }
  if (o && [void 0, null].includes(y))
    throw new Error("Missing required prop");
  return i ? $(t, {
    ...r,
    default: e(y),
    defaultIsDynamic: !1
  }) : y;
}
function _r(t) {
  const r = Array.from(J(t));
  return r[0] = r[0].toUpperCase(), r.unshift("o", "n"), r.join("");
}
function tu(t, {
  props: r = [],
  camelizePropNames: n = !1
} = {}) {
  const e = {
    props: {},
    attrs: {},
    listeners: {},
    hooks: {},
    slots: {}
  };
  let i;
  if (Array.isArray(r))
    i = n ? r.map((o) => J(o)) : r;
  else if (n) {
    i = [];
    for (const o in r)
      i.push(J(o));
  } else
    i = Object.keys(r);
  for (const o in t)
    if (o.startsWith("@")) {
      const a = o.substring(1);
      if (St)
        if (a.startsWith("vue:"))
          e.hooks[_r(a.replace("vue:", "vnode-"))] = t[o];
        else {
          if (a.startsWith("vnode"))
            throw new Error("@vnode-* hooks are no longer supported. Use the vue: prefix instead. For example, @vnode-mounted should be changed to @vue:mounted. @vnode-* hooks support has been removed in Vue 3.4.");
          e.listeners[_r(a)] = t[o];
        }
      else
        a.startsWith("hook:") ? e.hooks[a] = t[o] : e.listeners[a] = t[o];
    } else if (o.startsWith("#")) {
      const a = o.substring(1);
      a && (e.slots[a] = t[o]);
    } else {
      const a = n ? J(o) : o;
      i.includes(a) ? e.props[a] = t[o] : e.attrs[o] = t[o];
    }
  return e;
}
const Or = "JsonEditorVue", F = {}, wr = {}, tt = St ? "modelValue" : "value", Ar = St ? "update:modelValue" : "input", rt = [
  "mainMenuBar",
  "navigationBar",
  "statusBar",
  "askToFormat",
  "readOnly",
  "escapeControlCharacters",
  "escapeUnicodeCharacters",
  "flattenColumns"
], xr = {
  [tt]: {},
  mode: {
    type: String
  },
  debounce: {
    type: Number
  },
  stringified: {
    type: Boolean,
    default: void 0
  },
  ...Object.fromEntries(
    rt.map((t) => [
      t,
      {
        type: Boolean,
        default: void 0
      }
    ])
  )
}, eu = on({
  name: Or,
  install(t, r) {
    const n = tu(r || {}, { props: xr });
    Object.assign(F, n.props), Object.assign(wr, n.attrs), t.component(Or, this);
  },
  props: xr,
  emits: {
    [Ar](t) {
      return !0;
    },
    "update:mode": function(t) {
      return !0;
    }
  },
  setup(t, { attrs: r, emit: n, expose: e }) {
    var b;
    const i = (b = an()) == null ? void 0 : b.proxy, o = pt(), a = pt(!1), c = pt();
    cn(() => {
      var s;
      c.value = $([t.mode, F.mode], {
        type: String
      }), (s = o.value) == null || s.updateProps({
        mode: c.value || nn.tree
      });
    });
    const u = (s) => {
      n("update:mode", s);
    };
    F.mode !== void 0 && t.mode === void 0 && u(F.mode);
    const f = Rt(() => $([t.debounce, F.debounce, 100], {
      type: Number
    })), l = Rt(() => $([t.stringified, F.stringified, !0], {
      type: Boolean
    }));
    let p = JSON.parse;
    const v = Ln((s) => {
      a.value = !0, !l.value && s.text && (o.value && !o.value.validate() && (s.json = p(s.text)), s.text = void 0), n(
        Ar,
        s.text === void 0 ? s.json : s.text
      );
    }, f.value), y = (s, O) => (...d) => {
      s(...d), O(...d);
    };
    return e == null || e({ jsonEditor: o }), un(() => {
      var s;
      (s = o.value) == null || s.destroy();
    }), fn(() => {
      var _;
      const s = $([t[tt], F[tt]]), O = Object.fromEntries(
        Array.from(rt, (h) => [h, $([t[h], F[h]])]).filter(
          ([, h]) => h !== void 0
        )
      ), d = $(
        [
          O,
          r,
          wr,
          {
            onChange: v,
            onChangeMode: u,
            mode: c.value,
            ...s !== void 0 && {
              content: {
                [typeof s == "string" && c.value === "text" && l.value ? "text" : "json"]: s
              }
            }
          }
        ],
        {
          camelizeObjectKeys: !0,
          mergeFunction: y,
          type: Object
        }
      );
      p = ((_ = d.parser) == null ? void 0 : _.parse) || JSON.parse, o.value = new en({
        target: i == null ? void 0 : i.$refs.jsonEditorRef,
        props: d
      }), vt(
        () => t[tt],
        (h) => {
          if (a.value) {
            a.value = !1;
            return;
          }
          o.value && o.value.set(
            [void 0, ""].includes(h) ? {
              text: ""
            } : {
              [typeof h == "string" && c.value === "text" && l.value ? "text" : "json"]: h
            }
          );
        },
        {
          deep: !0
        }
      ), vt(
        () => Array.from(rt, (h) => t[h]),
        (h) => {
          var w;
          (w = o.value) == null || w.updateProps(
            Object.fromEntries(Array.from(h, (A, m) => [rt[m], A]).filter(([, A]) => A !== void 0))
          );
        }
      ), vt(
        () => r,
        (h) => {
          var A, m;
          const w = {};
          (h.onChange || h["on-change"]) && (w.onChange = v), (h.onChangeMode || h["on-change-mode"]) && (w.onChangeMode = u), p = ((A = h.parser) == null ? void 0 : A.parse) || JSON.parse, (m = o.value) == null || m.updateProps(
            Object.getOwnPropertyNames(w).length > 0 ? $([h, w], {
              camelizeObjectKeys: !0,
              mergeFunction: y,
              type: Object
            }) : h
          );
        },
        {
          deep: !0
        }
      ), e || (e = (h) => {
        for (const w in h)
          i[w] = sn(h[w]);
      }, e({ jsonEditor: o }));
    }), () => ln("div", { ref: "jsonEditorRef" });
  }
});
export {
  eu as default
};
//# sourceMappingURL=json-editor-vue.mjs.map
